var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgGrid15(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 640,
    height: 360,
    viewBox: "0 0 640 360",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1511_18096)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 640,
    height: 360,
    fill: "#FFC900"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M658.381 0H-18.3811V359.867H658.381V0Z",
    fill: "#FFC900"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M562.927 257.04C540.571 267.275 515.393 278.014 515 278.18L530.39 245.489C530.39 245.489 541.143 240.586 552.546 235.426L562.927 257.04Z",
    fill: "#23A094",
    stroke: "black",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M594.217 227.254L599.367 224.706C600.136 224.326 601.068 224.616 601.487 225.364L603.076 228.216C603.529 229.024 603.205 230.05 602.367 230.452L596.922 233.068C596.106 233.461 595.123 233.102 594.755 232.269L593.46 229.349C593.11 228.562 593.443 227.634 594.217 227.254Z",
    fill: "black",
    stroke: "black",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M592.02 242.807C585.878 246.304 574.8 251.601 562.927 257.043L552.546 235.429C562.038 231.141 571.979 226.673 576.548 224.707C594.195 217.119 603.179 236.455 592.02 242.807Z",
    fill: "black",
    stroke: "black",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M601.324 225.135L607.893 222.108C608.423 221.865 609.051 222.027 609.397 222.502C609.808 223.066 609.662 223.857 609.081 224.242L603.072 228.217L601.324 225.135Z",
    fill: "black",
    stroke: "black",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M524.122 168.984C523.408 170.399 522.686 171.835 521.951 173.28L505.671 165.461C506.441 163.969 507.206 162.49 507.962 161.023L524.122 168.984Z",
    fill: "white",
    stroke: "black",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M505.671 165.461L521.951 173.28C513.104 190.795 503.351 209.861 500.748 214.94C500.389 215.645 499.504 215.902 498.82 215.496L485.392 207.587C484.759 207.211 484.528 206.416 484.866 205.762C487.302 201.038 496.777 182.676 505.671 165.461Z",
    fill: "#FF90E8",
    stroke: "black",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M555.766 117.294C554.68 119.688 552.184 125.143 550.778 127.798C545.897 137.002 540.11 135.676 537.495 141.807C536.114 145.03 530.554 156.222 524.122 168.983L507.962 161.023C514.783 147.83 520.844 136.117 522.527 132.919C526.9 124.608 520.865 115.255 522.899 111.189C524.19 108.607 526.562 104.157 527.716 102.015C528.079 101.339 528.921 101.091 529.597 101.459L555.172 115.515C555.804 115.862 556.061 116.635 555.766 117.294Z",
    fill: "#23A094",
    stroke: "black",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M529.913 101.635L545.517 70.8125L563.86 97.2749L554.949 115.392L529.913 101.635Z",
    fill: "white",
    stroke: "black",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M548.214 74.7031L539.815 90.8456",
    stroke: "black",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M550.889 78.5625L543.76 91.9006",
    stroke: "black",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M553.633 82.7734L544.277 100.002",
    stroke: "black",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M556.501 86.7266L549.889 98.4786",
    stroke: "black",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M558.98 90.2305L551.231 104.06",
    stroke: "black",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M561.394 94.0352L554.565 106.54",
    stroke: "black",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M416.637 205.492H394.396L330.967 140.601L339.173 132.705C348.473 131.855 360.983 152.016 416.637 205.492Z",
    fill: "#23A094",
    stroke: "black",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M431.147 205.492H416.637C360.983 152.015 348.473 131.854 339.173 132.705L347.379 124.805L431.147 205.492Z",
    fill: "#FF90E8",
    stroke: "black",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M298.208 98.9464L300.879 98.9336C301.802 98.9336 302.738 98.9934 303.666 99.1131C304.555 99.22 305.469 99.3953 306.384 99.6261C306.931 99.7672 307.452 99.9211 307.94 100.088C308.829 100.383 309.726 100.742 310.589 101.152C310.735 101.225 311.107 101.405 311.107 101.405L317.458 107.757L311.581 112.323L298.208 98.9464Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M300.883 100.001C301.653 100.001 302.55 100.044 303.533 100.172C304.341 100.27 305.213 100.428 306.127 100.659C306.645 100.792 307.136 100.937 307.602 101.095C308.564 101.412 309.41 101.766 310.136 102.113C310.252 102.168 310.367 102.224 310.478 102.279L315.851 107.653L311.671 110.898L309.008 108.234L306.512 105.738L302.238 101.463L300.777 100.001C300.811 100.001 300.849 100.001 300.883 100.001ZM300.883 97.8633H300.764L295.644 97.8889L299.264 101.51L300.725 102.972L304.999 107.247L307.495 109.744L310.158 112.407L311.491 113.741L312.978 112.586L317.158 109.342L319.073 107.854L317.359 106.14L311.987 100.766L311.743 100.522L311.431 100.368C311.312 100.309 311.188 100.249 311.064 100.189C310.149 99.7528 309.209 99.3766 308.269 99.0646C307.773 98.8978 307.226 98.7354 306.657 98.59C305.691 98.3464 304.73 98.1668 303.79 98.0514C302.832 97.9274 301.849 97.8633 300.883 97.8633Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M307.602 101.099L304.738 103.968L302.238 101.467L303.533 100.176C304.341 100.274 305.213 100.432 306.127 100.663C306.644 100.796 307.136 100.941 307.602 101.099Z",
    fill: "#FFC900"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M312.722 104.528L309.008 108.239L306.512 105.742L310.136 102.117C310.252 102.173 310.367 102.228 310.478 102.284L312.722 104.528Z",
    fill: "#FF90E8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M325.834 132.191C317.718 125.714 313.201 119.635 310.833 115.646C309.286 113.043 309.696 109.721 311.837 107.579C314.03 105.386 317.453 105.002 320.065 106.673C323.92 109.144 329.882 113.624 336.955 121.183L325.834 132.191Z",
    fill: "#FF90E8",
    stroke: "black",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M347.379 124.806L330.967 140.602L323.198 132.651L339.605 117.32L347.379 124.806Z",
    fill: "white",
    stroke: "black",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M447.508 127.684L411.329 77.8844C412.227 77.397 414.689 79.013 415.945 78.4059C416.834 77.9784 415.381 73.9343 416.437 73.4811C417.556 73.0023 419.569 75.9136 420.907 75.4904C421.736 75.2296 421.125 72.19 422.014 71.878C423.036 71.5189 424.595 74.9218 425.745 74.6268C426.861 74.3404 426.314 70.4287 427.51 70.0312C428.536 69.6934 430.164 73.4768 431.327 73.2716C432.541 73.0579 432.263 68.9453 433.541 68.552C434.797 68.1672 435.246 71.9549 436.699 71.9164C437.96 71.8822 438.045 67.7526 439.49 67.3208C440.567 67.0002 441.123 71.677 442.405 71.9164C443.802 72.1772 444.311 67.6072 445.768 66.6624C446.85 65.9656 447.273 71.4804 447.944 71.506C448.67 71.5317 450.064 67.231 450.773 67.278C451.901 67.3507 451.897 70.8391 452.987 70.9717C454.132 71.1127 455.44 67.8936 456.556 68.0561C457.633 68.2143 457.646 71.7796 458.688 71.9934C459.706 72.2029 461.714 68.2485 462.71 68.4665C463.723 68.6888 462.932 72.78 463.898 73.0622C464.736 73.3058 466.809 70.2791 467.629 70.5185C468.668 70.8178 467.672 74.9603 468.655 75.3194C469.818 75.7426 471.732 72.4679 472.882 72.8142C473.608 73.0365 472.634 77.0166 473.335 77.2859C474.173 77.6108 476.677 74.2292 477.464 74.6054C478.263 74.9859 477.152 78.6411 477.887 79.0515C479.194 79.7739 480.507 76.6532 481.908 76.837C482.908 76.9695 481.374 80.4708 482.276 81.1847C483.644 82.2748 487.328 80.7358 487.969 81.159C475.331 97.3229 462.697 113.491 450.059 129.655L447.508 127.684Z",
    fill: "white",
    stroke: "black",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M466.078 86.7148L451.777 114.832",
    stroke: "black",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M456.778 81.9219L451.145 111.167",
    stroke: "black",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M442.127 83.543L448.115 108.843",
    stroke: "black",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M434.519 96.543L445.862 110.813",
    stroke: "black",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M449.149 206.525H439.729L444.23 110.602C444.35 108.092 446.418 106.117 448.931 106.117C451.615 106.117 453.756 108.362 453.633 111.042L449.149 206.525Z",
    fill: "#FFC900",
    stroke: "black",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M257.807 132.656H241.724V205.563H257.807V132.656Z",
    fill: "#FF90E8",
    stroke: "black",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M241.724 132.653V70.3359C241.724 70.3359 245.951 86.4571 260.114 102.753C253.952 113.668 250.464 117.455 249.763 132.657H241.724V132.653Z",
    fill: "white",
    stroke: "black",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M248.036 111.483C247.592 110.752 246.348 108.507 246.647 105.472C246.9 102.911 248.109 101.159 248.66 100.453C249.032 102.146 249.19 103.45 250.776 105.519C249.306 107.259 248.69 109.191 248.036 111.483Z",
    fill: "#98282A",
    stroke: "black",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M133.731 115.048C133.09 106.707 129.851 94.515 123.658 87.2646C117.149 79.6422 104.964 76.4744 99.0913 67.5268C99.0913 67.5268 99.1939 69.3608 100.1 71.105C96.839 69.9806 94.5482 68.5357 92.0138 66.0391C92.5053 67.7833 95.3089 70.8185 95.3089 70.8185C92.6548 69.8353 89.9495 68.3177 89.9495 68.3177C91.0991 71.0066 94.608 72.6568 94.8644 73.4819C95.1209 74.307 95.3388 113.21 126.042 120.225L133.731 115.048Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M127.235 117.871L116.469 104.336L117.978 103.751L113.199 96.9236L115.883 97.1758L110.31 89.0447L114.417 90.0108L110.31 83.7266L120.029 94.7433L115.631 93.4437L122.628 102.494L118.225 100.797L127.235 117.871Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M179.312 213.516L123.175 121.962L134.714 114.57L202.776 205.56L179.312 213.516Z",
    fill: "#23A094",
    stroke: "black",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M145.501 128.992L132.415 137.025L136.201 143.202L149.891 134.858L145.501 128.992Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M147.66 131.875L134.295 140.092",
    stroke: "#FF90E8",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55.5488 179.758L167.555 263.557L166.764 260.393L58.4294 179.758H55.5488Z",
    fill: "#FFC900"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M165.585 256.389L59.0151 177.087V173.492H64.1566L164.512 248.788L165.585 256.389Z",
    fill: "#FFC900"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64.2463 166.711L163.901 241.562L164.187 245.589L64.7549 170.892L64.2463 166.711Z",
    fill: "#FFC900"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M166.683 286.946C166.957 287.087 167.247 287.211 167.559 287.317C175.44 290.032 177.881 278.879 177.881 278.879L179.864 275.848L173.855 271.038L168.457 268.332C166.2 270.414 164.204 274.27 163.55 278.006C163.46 278.515 163.396 279.02 163.362 279.516C163.328 279.982 163.315 280.443 163.332 280.892C163.379 282.234 163.657 283.487 164.23 284.547",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M166.683 286.946C166.957 287.087 167.247 287.211 167.559 287.317C175.44 290.032 177.881 278.879 177.881 278.879L179.864 275.848L173.855 271.038L168.457 268.332C166.2 270.414 164.204 274.27 163.55 278.006C163.46 278.515 163.396 279.02 163.362 279.516C163.328 279.982 163.315 280.443 163.332 280.892C163.379 282.234 163.657 283.487 164.23 284.547",
    stroke: "black",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M170.722 271.664C166.585 278.581 168.974 281.685 172.346 280.347C174.808 279.372 172.252 273.554 172.252 273.554L170.722 271.664Z",
    fill: "#FFC900",
    stroke: "black",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M173.419 278.496L172.825 279.53L172.35 280.347C169.171 280.505 166.166 280.595 163.332 280.89C157.687 281.471 152.716 282.852 148.382 287.204C147.673 287.922 147.711 289.115 148.481 289.765C150.831 291.752 156.592 292.783 164.23 284.545C164.525 285.092 164.901 285.592 165.363 286.024C165.743 286.379 166.183 286.687 166.683 286.943C162.726 293.044 150.028 296.087 145.707 292.261C140.608 287.742 147.023 282.587 152.494 280.65C154.644 279.894 159.093 278.62 163.55 278.004C167.273 277.482 171.008 277.423 173.419 278.496Z",
    fill: "white",
    stroke: "black",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M164.892 286.618C159.768 292.595 147.587 294.997 145.916 289.525C144.284 284.186 155.849 280.377 163.362 279.513C163.7 279.471 164.033 279.436 164.354 279.411C166.192 279.257 167.641 279.171 168.73 279.129C170.513 279.056 171.337 279.09 171.337 279.09",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M534.089 242.202V248.401C534.089 256.049 531.858 263.179 528.011 269.164H168.978C165.132 263.179 162.901 256.049 162.901 248.401V244.309H187.194V228.68H165.346C170.812 214.102 184.877 203.727 201.366 203.727H495.624C516.869 203.727 534.089 220.951 534.089 242.202Z",
    fill: "#23A094",
    stroke: "black",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M528.011 269.164C526.173 272.028 523.968 274.628 521.463 276.902H175.526C173.021 274.628 170.816 272.028 168.978 269.164H528.011Z",
    fill: "white",
    stroke: "black",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M521.463 276.902C518.967 279.168 516.177 281.109 513.155 282.661H183.834C180.813 281.109 178.022 279.168 175.526 276.902H521.463Z",
    fill: "white",
    stroke: "black",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M513.155 282.66C507.898 285.353 501.94 286.875 495.623 286.875H201.366C195.049 286.875 189.091 285.353 183.834 282.66H513.155Z",
    fill: "white",
    stroke: "black",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M455.474 255.638C455.594 255.916 455.923 256.027 456.18 255.865C458.962 254.116 466.142 250.234 475.622 251.154C481.678 251.739 486.229 254.048 488.854 255.694C489.178 255.899 489.597 255.66 489.597 255.279V229.03C489.597 228.701 489.277 228.462 488.965 228.564C485.575 229.646 479.985 230.933 473.113 230.291C465.3 229.565 459.483 226.688 456.278 224.768C456 224.601 455.637 224.751 455.564 225.067C453.692 232.985 442.448 238.307 438.819 239.838C438.422 240.004 438.417 240.569 438.815 240.735C442.093 242.125 451.666 246.802 455.474 255.638Z",
    fill: "white",
    stroke: "black",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M459.988 235.336L484.263 247.738",
    stroke: "black",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M485.097 233.762L458.898 248.395",
    stroke: "black",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M187.193 228.68V244.309H162.901V242.202C162.901 241.988 162.901 241.774 162.909 241.56H181.398V231.429H164.431C164.7 230.497 165.003 229.577 165.345 228.68H187.193Z",
    fill: "black",
    stroke: "black",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M181.398 231.43V241.561H162.909C162.965 238.047 163.491 234.649 164.431 231.43H181.398Z",
    fill: "white",
    stroke: "black",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31 149.25L63.5 164.25L71 186L50.25 178.25L31 149.25Z",
    fill: "#FBFBF9",
    stroke: "black",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.625 161.75L44.25 155.75L31.125 149.625L39.625 161.75Z",
    fill: "black",
    stroke: "black",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63.75 164.75L166.75 242L169 266.25L51.25 178.75H57.25V172H63.75V164.75Z",
    fill: "#FFC900",
    stroke: "black",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63.375 171.625L168.25 250.25",
    stroke: "black",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57 178.625L168.75 261",
    stroke: "black",
    strokeWidth: 2
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1511_18096"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 640,
    height: 360,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGrid15);
export default __webpack_public_path__ + "static/media/grid15.8452394dac8e9f02e8b1ff9d169a1877.svg";
export { ForwardRef as ReactComponent };